import styled from 'styled-components'

export const Container = styled.div`
    display: flex;

    .fill{
       min-width: 4rem;
    }

`

export const CouponsContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 28rem;
    margin: 1rem auto 5rem auto;

    @media (max-width: 460px){
        width: 80%;
    }
`

export const ButtonFixedContainer = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 5px 0 5px 0;
    background: #FFF;
    z-index: 12;

    div{
        max-width: 10rem;
        margin: 0 auto;
    }
`
